<template>
  <div
    class="bubble-chart__tooltip"
    :style="{
      top: `${top}px`,
      left: `${left}px`,
      visibility: value ? 'visible' : 'hidden',
    }"
  >
    <span class="bubble-chart__tooltip-text" v-html="text" />
  </div>
</template>

<script>
export default {
  name: 'BubbleChartTooltip',
  props: {
    value: Boolean, // show boolean
    text: String,
    top: Number,
    left: Number,
  },
};
</script>

<style lang="scss" scoped>
.bubble-chart__tooltip {
  font-family: 'Noto Sans Regular', sans-serif;
  position: absolute;
  pointer-events: none;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 10px;
  box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.17);
  border-radius: 10px;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.15);

  &-text {
    font-style: normal;
    font-weight: normal;
    font-family: 'Noto Sans Regular', sans-serif;
    font-size: 13px;
    line-height: 18px;
    color: #373839;
    flex: none;
    order: 0;
    align-self: center;
    flex-grow: 0;
  }
}
</style>
